import { Vue } from 'vue-property-decorator';
import { AxiosResponse, AxiosRequestConfig } from 'axios';
import { IRequestConfigModel } from '../models/request.model';

export default {
  setConfig(context: Vue, config?: IRequestConfigModel): AxiosRequestConfig {
    const configRequest = {
      headers: {
        'X-Api-Key': context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_KEY
      }
    } as AxiosRequestConfig;

    if (config != null) {
      configRequest.headers = Object.assign(configRequest.headers, config.headers);
      configRequest.params = config.params;
    }

    return configRequest;
  },

  get<ResultType>(context: Vue, url: string, config?: IRequestConfigModel): Promise<ResultType> {
    return context.$http.get(url, this.setConfig(context, config))
      .then(response => this.handleResponse<ResultType>(response))
      .catch(error => this.handleResponse<ResultType>(error.response));
  },

  post<DataType, ResultType>(context: Vue, url: string, data: DataType, config?: IRequestConfigModel): Promise<ResultType> {
    return context.$http.post(url, data, this.setConfig(context, config))
      .then(response => this.handleResponse<ResultType>(response))
      .catch(error => this.handleResponse<ResultType>(error.response));
  },

  handleResponse<ResultType>(response: AxiosResponse<ResultType>): Promise<ResultType> {
    if (response == null) {
      return Promise.reject(null);
    }

    if (response.status == 400) {
      return Promise.reject(response);
    }
    else if (response.status == 200 || response.status == 201) {
      return Promise.resolve(response.data);
    }

    return Promise.reject(null);
  }
}